<template>
  <div class="exclusive-logged-content">
    <div v-if="!hasLiveReminder">
      <TextIcon
        iconSize="21,19"
        iconPos="-100,-17"
        class="text-label mb-2"
      >RESERVE SEU LUGAR</TextIcon>

      <div v-if="!isLogged">
        <p class="desc mb-3">Cadastre-se para assistar essa e várias outras lives <b>GRÁTIS</b>.</p>
        <PrimaryButton
          :full="true"
          @clicked="openAuthModal"
        >Cadastrar / Entrar</PrimaryButton>
      </div>

      <div v-else >
        <p class="desc mb-3">Você será <strong>notificado</strong> quando a live começar.</p>
        <PrimaryButton
          :full="true"
          @clicked="reminderSignUp"
        >Reservar</PrimaryButton>
      </div>
    </div>

    <div v-else>
      <TextIcon
        iconSize="17,13"
        iconPos="-63,-126"
        class="text-label mb-2"
      >RESERVADO</TextIcon>
      <p class="desc">Agora é só aguardar. Você será <strong>notificado</strong> quando a live começar.</p>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import TextIcon from '@/components/layout/text/TextIcon'
  import PrimaryButton from '@/components/buttons/PrimaryButton'
  import AuthFormModal from '@/components/modals/auth/AuthFormModal'

  export default {
    components: {
      TextIcon,
      PrimaryButton,
    },
    mounted () {
      if (this.isLogged) {
        this.$store.dispatch('live/fetchUserLiveReminder', this.liveId)
      }
    },
    computed: {
      ...mapGetters('user', ['isLogged', 'user']),
      ...mapGetters('live', ['hasLiveReminder']),
      liveId () {
        return this.$route.params.id
      }
    },
    methods: {
      reminderSignUp () {
        this.$store.dispatch('live/liveReminderSignUp', this.liveId)
      },
      openAuthModal () {
        this.$modal.show(AuthFormModal, {}, { width: '343px' }, {
          'closed': () => this.$store.commit('auth/resetModal')
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .text-label {
    font-weight: 500;
    color: #fff;
    font-size: 15px;
  }

  .desc {
    font-size: 14px;
    margin: 0;
    color: rgba(#fff, .9);
  }

  .button-base {
    background: rgba(#fff, .3);

    &:hover {
      background: rgba(#fff, .2)
    }
  }
</style>